import { render, staticRenderFns } from "./ImageDetails.vue?vue&type=template&id=6bbbe410&scoped=true"
import script from "./ImageDetails.vue?vue&type=script&lang=js"
export * from "./ImageDetails.vue?vue&type=script&lang=js"
import style0 from "./ImageDetails.vue?vue&type=style&index=0&id=6bbbe410&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbbe410",
  null
  
)

export default component.exports